import { SsMount } from 'src/js/dom/mount.js';

export class SsPage extends SsMount {
  constructor ( elm ) {
    super( elm );
    this.displayType = 'flex';
  }

  open () {
    this.$.css( 'display', this.displayType );
  }

  close () {
    this.$.css( 'display', 'none' );
  }
}
